export default __webpack_public_path__ + "static/media/page-bg-circles.c31da976.png";